export const config = {
    defaultWsServerUrl: 'wss://n01.devant.cz/ws',
    defaultObsUrl: 'wss://n01.devant.cz/obs',
    defaultObsPassword: '',
    nakkaApiEndpoint: 'https://tk2-228-23746.vs.sakura.ne.jp',
    fakeGameState: false, // for debug
};
